import {
  LineChart,
  CurrencyValue,
  Flex,
  ChartSkeleton,
  formatCurrency
} from '@blockanalitica/ui';
import { useTheme } from 'styled-components';
import type { SimpleChartData } from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import { ChartConfig } from '@blockanalitica/ui/package/types/src/components/charts/Chart';
import { useMemo } from 'react';
import { useApi } from '@/api';

export default function AtRiskHistoryChart({
  chartDaysAgo
}: {
  chartDaysAgo: string;
}) {
  const [data, error] = useApi<SimpleChartData[]>({
    url: `/at-risk/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  //@ts-ignore
  const defaultConfig: ChartConfig = useMemo(() => {
    return {
      options: {
        fill: false
      }
    };
  }, []);

  const yScaleValueFormatter = (value: string | number) => {
    return formatCurrency(Number(value), { maximumFractionDigits: 5 });
  };
  const valueFormatter = (value: string | number) => {
    return (
      <CurrencyValue
        value={value}
        variant="dynamic"
        options={{ currency: 'USD' }}
      />
    );
  };
  const theme = useTheme();

  const datasets = useMemo(
    () => [
      {
        xField: 'date',
        yField: 'drop_10',
        label: '-10%',
        borderColor: theme.colors.secondary
      },
      {
        xField: 'date',
        yField: 'drop_20',
        label: '-20%',
        borderColor: theme.colors.primary
      },
      {
        xField: 'date',
        yField: 'drop_30',
        label: '-30%',
        borderColor: theme.colors.warning
      },
      {
        xField: 'date',
        yField: 'drop_40',
        label: '-40%',
        borderColor: theme.colors.error
      }
    ],
    [theme.colors]
  );

  if (error) {
    throw error;
  }

  if (!data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <ChartSkeleton />
      </Flex>
    );
  }

  return (
    <LineChart
      key={chartDaysAgo}
      data={data}
      datasets={datasets}
      valueFormatter={valueFormatter}
      yScaleValueFormatter={yScaleValueFormatter}
      config={defaultConfig}
      daysAgo={chartDaysAgo}
    />
  );
}
